import { Container, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { gsap } from "gsap";
type Timeline = gsap.core.Timeline;

export class TokensField extends Container {
    private static readonly COLLECT_TOKENS_ANIMATION_TIME = 2.5;

    private readonly commonResources: CommonResourcesPackage;

    private background: Sprite;
    private icon: Sprite;
    private textField: Text;
    private currentTokens: string;
    private readonly tokensAnimation: Timeline;

    public constructor(commonResources: CommonResourcesPackage, value: string = "0") {
        super();
        this.commonResources = commonResources;
        this.currentTokens = value;
        this.tokensAnimation = new gsap.core.Timeline();
        this.build();
        this.layout();
    }

    private build(): void {
        this.background = new Sprite(this.commonResources.assets_common_ui_top_panel_tokens_field_png);
        this.addChild(this.background);
        this.icon = new Sprite(this.commonResources.assets_common_ui_top_panel_token_icon_png);
        this.addChild(this.icon);
        this.textField = new Text(StringFormatExtention.tokensFormat(this.currentTokens), new TokensFieldTextStyle());
        this.addChild(this.textField);
    }

    private layout(): void {
        this.icon.position.set(8, (this.background.height - this.icon.height) * 0.5);
        if (this.textField.width >= this.width * 0.55) {
            this.textField.scale.set(this.width * 0.55 / (this.textField.width));
        }
        this.textField.position.set((this.width - this.textField.width + this.icon.width) * 0.5, (this.background.height - this.textField.height) * 0.5);
    }

    public async updateTokens(value: string): Promise<void> {
        const target = { value: this.currentTokens };
        this.currentTokens = value;
        this.tokensAnimation.clear();
        await this.tokensAnimation.to(target, { value: this.currentTokens, onUpdate: () => this.updateTokenText(target.value), duration: TokensField.COLLECT_TOKENS_ANIMATION_TIME, ease: "power1.in" });
    }

    private updateTokenText(value: string): void {
        this.textField.text = StringFormatExtention.tokensFormat(value);
        if (this.textField.width >= this.width * 0.55) {
            this.textField.scale.set(this.width * 0.55 / (this.textField.width));
        }
        this.textField.position.set((this.width - this.textField.width + this.icon.width) * 0.5, (this.background.height - this.textField.height) * 0.5 + 3);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.tokensAnimation.kill();
        super.destroy(options);
    }
}

class TokensFieldTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36,
            miterLimit: 0
        }));
    }
}
